import { CodeBlockVisitor } from "./CodeBlockVisitor.js";
import { MdastCodeVisitor } from "./MdastCodeVisitor.js";
import { Appender, defaultCodeBlockLanguage$, insertDecoratorNode$, codeBlockEditorDescriptors$, addExportVisitor$, addLexicalNode$, addImportVisitor$, addActivePlugin$ } from "../core/index.js";
import { $createCodeBlockNode, CodeBlockNode } from "./CodeBlockNode.js";
import { $convertPreElement, $isCodeBlockNode, useCodeBlockEditorContext } from "./CodeBlockNode.js";
import { Signal, withLatestFrom, map } from "@mdxeditor/gurx";
import { realmPlugin } from "../../RealmWithPlugins.js";
const insertCodeBlock$ = Signal((r) => {
  r.link(
    r.pipe(
      insertCodeBlock$,
      withLatestFrom(defaultCodeBlockLanguage$),
      map(
        ([payload, defaultCodeBlockLanguage]) => () => $createCodeBlockNode({ language: defaultCodeBlockLanguage, ...payload })
      )
    ),
    insertDecoratorNode$
  );
});
const appendCodeBlockEditorDescriptor$ = Appender(codeBlockEditorDescriptors$);
const codeBlockPlugin = realmPlugin({
  update(realm, params) {
    realm.pub(defaultCodeBlockLanguage$, (params == null ? void 0 : params.defaultCodeBlockLanguage) ?? "");
  },
  init(realm, params) {
    realm.pubIn({
      [addActivePlugin$]: "codeblock",
      [defaultCodeBlockLanguage$]: (params == null ? void 0 : params.defaultCodeBlockLanguage) ?? "",
      [codeBlockEditorDescriptors$]: (params == null ? void 0 : params.codeBlockEditorDescriptors) ?? [],
      [addImportVisitor$]: MdastCodeVisitor,
      [addLexicalNode$]: CodeBlockNode,
      [addExportVisitor$]: CodeBlockVisitor
    });
  }
});
export {
  $convertPreElement,
  $createCodeBlockNode,
  $isCodeBlockNode,
  CodeBlockNode,
  appendCodeBlockEditorDescriptor$,
  codeBlockPlugin,
  defaultCodeBlockLanguage$,
  insertCodeBlock$,
  useCodeBlockEditorContext
};
